import React from 'react';
import { Form } from 'react-bootstrap';
import {
	METODO_LIMPEZA_OUTROS,
	OPCOES_METODO_LIMPEZA,
} from '../../../util/cadernoLPMA/metodoLimpeza';

interface MetodoLimpezaSelectProps {
	register: any;
	name: string;
	nameOutros: string;
	metodoSelecionado?: string | null;
	className?: string;
}

const estiloSelect: React.CSSProperties = {
	height: 'calc(1.5em + .75rem + 2px)',
};

export default function MetodoLimpezaSelect({
	register,
	name,
	nameOutros,
	metodoSelecionado,
	className,
}: MetodoLimpezaSelectProps) {
	const mostrarMetodoOutros = metodoSelecionado === METODO_LIMPEZA_OUTROS;

	return (
		<>
			<Form.Control
				as="select"
				ref={register}
				name={name}
				className={className}
				style={estiloSelect}
			>
				<option value="">Selecione</option>
				{OPCOES_METODO_LIMPEZA.map((opcao) => (
					<option key={opcao} value={opcao}>
						{opcao}
					</option>
				))}
			</Form.Control>
			{mostrarMetodoOutros ? (
				<Form.Control
					className="mt-2"
					ref={register}
					name={nameOutros}
					placeholder="Especificar método"
				/>
			) : null}
		</>
	);
}
